import { useState, useEffect, useRef } from 'react';

// Hook
export const useWindowSize = (): any => {
    const isClient = typeof window === 'object'; //Object represents browser window
    const lastWidth = useRef<any>();

    function getSize() {
        return {
            width: isClient ? window.innerWidth : undefined
        }
    }

    const [windowSize, setWindowSize] = useState(getSize)

    function handleResize() {
        if (window?.innerWidth !== lastWidth.current) {
            const width = getSize();
            lastWidth.current = width;
            setWindowSize(width)
        }
    }

    useEffect((): any => {
        if (!isClient) {
            return false
        } //Exit if not user/browser

        window.addEventListener('resize', handleResize) // <-- I am only interested in window.innerWidth !
        return () => window.removeEventListener('resize', handleResize)
    }, [isClient, handleResize]) // Empty array ensures that effect is only run on mount and unmount

    return windowSize

}